import { render, staticRenderFns } from "./FishData.vue?vue&type=template&id=8d5669f2&scoped=true"
import script from "./FishData.vue?vue&type=script&lang=js"
export * from "./FishData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5669f2",
  null
  
)

export default component.exports